export type Args = {
  listOfMessages: any;
  valueToSearch: string | any;
};

export const CheckInputFieldMessages = ({ valueToSearch, listOfMessages }: Args) => {
  return listOfMessages.find((element: { idInputField: any }) => element.idInputField === valueToSearch);
};
